import React, { useState } from 'react';
import FieldTextarea from '../../fields/FieldTextarea';
import Field from '../../fields/Field';
import ReactLoading from 'react-loading';

const Debugger = (props) => {
    const editorEl = document.getElementById('editor');

    const { setTagData, resetCanvases, setupCanvases, exportData, copyData, refreshProductRequest, forceTagEditor, isTagWizardLoading, isEditorLoading, modifyForNLIS, changeCurrentSideMask, exportedSVGs } = props;
    const [ mask, setMask ] = useState('');
    const [ baseData, setBaseData ] = useState('');
    const [ familyTitle, setFamilyTitle ] = useState(window.familyTitle);
    const [ familyTitleSlug, setFamilyTitleSlug ] = useState(window.familyTitleSlug);
    const [ currentProductID, setCurrentProductID ] = useState(window.currentProductID);
    const [ tagType, setTagType ] = useState(editorEl.getAttribute('data-tag-type'));

    const isLoading = isTagWizardLoading || isEditorLoading;

    const onChangeBaseData = e => setBaseData(e.target.value);
    const onChangeMask = e => setMask(e.target.value);

    const onMaskSubmit = e => {
        e.preventDefault();
        try {
            Promise.all([
                resetCanvases(),
                changeCurrentSideMask(mask),
            ]).then(() => {
                setupCanvases();
            });
        }
        catch (e) {
            console.error(e);
        }
    };

    const onBaseDataSubmit = e => {
        e.preventDefault();
        try {
            const convertedData = JSON.parse(baseData);

            Promise.all([
                resetCanvases(),
                setTagData(convertedData),
            ]).then(() => {
                setupCanvases();
            });
        }
        catch (e) {
            console.error(e);
        }
    };

    const onProductDetailSubmit = e => {
        e.preventDefault();

        window.familyTitle = familyTitle;
        window.familyTitleSlug = familyTitleSlug;
        window.currentProductID = Number(currentProductID);
        editorEl.setAttribute('data-tag-type', tagType);
        refreshProductRequest();
    };

    const printButtonLoading = () => (<ReactLoading
        className='button__spinner'
        type='spin'
        color='white'
        height={20}
        width={20}
    />);

    return (
        <React.Fragment>
            <div className="vspace">
                <h2 className="heading heading--lv2">Debugger</h2>
            </div>
            <div className="vspace">
                <button type="button" className="button button--border" onClick={() => exportData()}>
                    <span>Export JSON</span>
                </button>
                <button type="button" className="button button--border" onClick={() => copyData()}>
                    <span>Copy JSON</span>
                </button>
                <button type="submit" className="button button--border" onClick={() => modifyForNLIS()}>
                    <span>Modify for NLIS</span>
                </button>
            </div>
            <div className="vspace">
                <div className="row">
                    <div className="col-xs-12 col-md-5">
                        <div className="vspace vspace--small">
                            <h3 className="heading heading--lv2">Product Detail</h3>
                        </div>
                        <form className="form" onSubmit={onProductDetailSubmit}>
                            <div className="vspace vspace--small">
                                <Field
                                    isLoading={isLoading}
                                    autoComplete='off'
                                    animatedLabel='Family Title'
                                    label='Family Title'
                                    value={familyTitle}
                                    name='familyTitle'
                                    onChange={(e) => setFamilyTitle(e.target.value) }
                                />
                                <Field
                                    isLoading={isLoading}
                                    autoComplete='off'
                                    animatedLabel='Family Title Slug'
                                    label='Family Title Slug'
                                    value={familyTitleSlug}
                                    name='familyTitleSlug'
                                    onChange={(e) => setFamilyTitleSlug(e.target.value) }
                                />
                                <Field
                                    isLoading={isLoading}
                                    autoComplete='off'
                                    animatedLabel='Current Product ID'
                                    label='Current Product ID'
                                    value={currentProductID}
                                    name='currentProductID'
                                    onChange={(e) => setCurrentProductID(e.target.value) }
                                />
                                <Field
                                    isLoading={isLoading}
                                    autoComplete='off'
                                    animatedLabel='Tag Type'
                                    label='Tag Type'
                                    value={tagType}
                                    name='tagType'
                                    onChange={(e) => setTagType(e.target.value) }
                                />
                            </div>
                            <div className="row">
                                <div className="col-xs-6">
                                    <button type="submit" className="button button--block">
                                        <span>Refresh</span>
                                        {isLoading === true && printButtonLoading()}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-xs-12 col-md-7">
                        <div className="vspace vspace--small">
                            <h3 className="heading heading--lv2">Tag Data Detail</h3>
                        </div>
                        <form className="form" onSubmit={onBaseDataSubmit}>
                            <div className="vspace vspace--small">
                                <FieldTextarea
                                    isLoading={isLoading}
                                    autoComplete='off'
                                    animatedLabel='Base Data'
                                    label='Base Data'
                                    value={baseData}
                                    name='baseData'
                                    onChange={onChangeBaseData}
                                />
                            </div>
                            <div className="row">
                                <div className="col-xs-6">
                                    <button type="submit" className="button button--block">
                                        <span>Overwrite Tag Editor</span>
                                        {isLoading === true && printButtonLoading()}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="vspace">
                <div className="vspace vspace--small">
                    <h3 className="heading heading--lv2">Modify Current Side SVG Mask</h3>
                </div>
                <form className="form" onSubmit={onMaskSubmit}>
                    <div className="vspace vspace--small">
                        <FieldTextarea
                            isLoading={isLoading}
                            autoComplete='off'
                            animatedLabel='SVG Mask'
                            label='SVG Mask'
                            value={mask}
                            name='mask'
                            onChange={onChangeMask}
                        />
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <button type="submit" className="button button--block">
                                <span>Overwrite Current Mask</span>
                                {isLoading === true && printButtonLoading()}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div className="vspace">
                <div className="vspace vspace--small">
                    <h3 className="heading heading--lv2">Exported SVGs</h3>
                </div>
                {Object.entries(exportedSVGs).map(([side, exportedSVG]) => {
                    if(!exportedSVG) {
                        return '';
                    }

                    return (
                        <div className="vspace">
                            <h4 className="heading heading--lv2">{side}</h4>
                            <div dangerouslySetInnerHTML={{ __html: exportedSVG }} />
                        </div>
                    );
                })}
            </div>
        </React.Fragment>
    );
};

export default Debugger;
